import React from "react";
import { DropdownButton, Flex, Icon, Text } from "@jsq/ds/core";
import { RowItem, TypedAGGridCellRenderParams } from "../types";

interface Props {
  params: TypedAGGridCellRenderParams<RowItem>;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
}

export const OwnerOrControllerSummaryListActions = ({ params, onDelete, onEdit }: Props) => {
  const profileId = params.data.id;
  /** TODO: delete modal and actions had been separated into its own story so implement here */
  return (
    <>
      <DropdownButton
        data-testid={`dropdown-button-controller-individual-actions`}
        variant="muted"
        icon="ellipsis-h"
        direction="down"
        align="right"
        usePortal
      >
        <DropdownButton.Action onSelect={() => onEdit(profileId)}>
          <Flex alignItems="center" gap={8}>
            <Icon type="edit" />
            <Text>Edit</Text>
          </Flex>
        </DropdownButton.Action>
        <DropdownButton.Action onSelect={() => onDelete(profileId)}>
          <Flex alignItems="center" gap={8}>
            <Icon type="trash" />
            <Text>Delete</Text>
          </Flex>
        </DropdownButton.Action>
      </DropdownButton>
    </>
  );
};
